export default "__VITE_ASSET__CJT_wvtJ__"